// import 'core-js/stable'
import CoreuiVue from '@coreui/vue/src'
import router from './router'
import { hasAuthor, isAuthorized, roles, isLogin} from './security'
import { iconsSet as icons } from './assets/icons/icons'
import helper from './helper'
import Notifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import store from './store'
import App from './App'
import Vue from 'vue'
import babelpolyfill from 'babel-polyfill'

const plugin = {
  install () {
    Vue.prototype.$helper = helper
    Vue.prototype.$hasAuthor = hasAuthor
    Vue.prototype.$isAuthorized = isAuthorized
    Vue.prototype.$authRoles = roles()
    Vue.prototype.$isLogin = isLogin()
  }
}
// helper.agggg =56;
function toast({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const toastTypes = {
  success: 'success',
  error: 'error',
  warn: 'warn'
}
const options = {
  success: toast,
  error: toast,
  warn: toast
}
miniToastr.init({types: toastTypes})
Vue.use(Notifications, options)

Vue.use(CoreuiVue)
Vue.use(plugin)

new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  babelpolyfill,
  template: '<App/>',
  components: {
    App,
  },
})
